import Entity from '../entity'

export default class OrderItem extends Entity<number>{
    orderId: number  = null;
    productId: number  = null;
    productNo: string;
    productName: string  = null;
    unitPrice: number  = null;
    productImageUrl: string  = null;
    quantity: number  = null;
    tenantId: number  = null;
    buyerRemark: string  = null;
    vendorNo: string  = null;
    creationTime: Date;
    remark: string  = null;
    authMode: string;

}